<template>
	<div class="w-100 h-100">
		<b-container fluid>
			<h2 class="tw-mb-0 text-aegis-dk">IgG ELISA</h2>
			<p class="tw-italic tw-text-gray-700">Batch Upload with CSV file and Data View</p>
		</b-container>

		<hr />

		<b-card no-body>
			<b-tabs card fill>
				<b-tab
					:title="'Batch Uploads'"
					active
				>
					<b-card-text>
						<b-container>
							<!-- file upload form -->
							<b-row>
								<b-col md="6" offset-md="3" class="mt-3">
									<b-form-file
										id="file"
										v-model="selectedFile"
										:state="Boolean(selectedFile)"
										placeholder="Choose a file or drop it here..."
										drop-placeholder="Drop file here..."
										size="lg"
										accept="text/csv, .csv"
									></b-form-file>
								</b-col>
							</b-row>

							<!-- alert if uploaded file is incorrect -->
							<b-row>
								<b-col md="6" offset-md="3" class="mt-3">
									<b-alert
										v-if="uploading_error"
										show
										dismissible
										variant="danger"
									>
										Found error(s). Please check the data file and reupload.
									</b-alert>
								</b-col>
							</b-row>

							<!-- Uplod button -->
							<b-row>
								<b-col md="6" offset-md="3" class="mt-3">
									<b-button
										@click="onUpload"
										variant="success"
										size="lg"
										block
										:disabled="uploading"
									>
										{{ uploading ? 'Uploading...' : 'Upload' }}
										<b-spinner
											v-if="uploading"
											small
										></b-spinner>
									</b-button>
								</b-col>
							</b-row>
						</b-container>

						<hr />

						<!-- search filename -->
						<b-container fluid>
							<b-row>
								<b-col>
									<b-form-input
										v-model="search.upload"
										placeholder="Search Filename"
										size="lg"
										@keyup="find"
									></b-form-input>
								</b-col>
							</b-row>
						</b-container>

						<hr>

						<b-table
							striped
							borderless
							:fields="fields"
							:items="uploads"
							class="table-sm tw-text-sm"
						>
							<template v-slot:cell(accepted)="data">
								<div style="display: flex; align-items: center;">
									<div style="margin-right: auto">{{ data.value }}</div>
								<i
									v-if="data.value != 0"
									class="fas fa-table tw-cursor-pointer"
									style="padding-right: 1em"
									title="View accepted records"
									@click="download_elisa_accepted(data.item)"
								></i>
								<i
									v-if="data.value != 0"
									class="fas fa-download tw-cursor-pointer"
									style="padding-right: 3em"
									title="Download accepted records"
									@click="download_elisa_accepted_csv(data.item)"
								></i>
								</div>
							</template>
							<template v-slot:cell(rejected)="data">
								<div style="display: flex; justify-content: space-between; align-items: center">
									<div style="margin-right: auto">{{ data.value }}</div>
								<i
									v-if="data.value != 0"
									class="fas fa-table tw-cursor-pointer"
									style="padding-right: 1em"
									title="View rejected records"
									@click="download_elisa_rejected(data.item)"
								></i>
								<i
									v-if="data.value != 0"
									class="fas fa-download tw-cursor-pointer"
									style="padding-right: 3em"
									title="Download rejected records"
									@click="download_elisa_rejected_csv(data.item)"
								></i>
								</div>
							</template>
						</b-table>
					</b-card-text>
				</b-tab>

				<!-- <b-tab
					:title="'View All Data'"
					@click="refresh_all_records_table"
					:disabled="uploading"
				>
					<b-card-text>
						<b-row>
							<b-col>
								<b-alert
									v-if="updating_table"
									show
								>
									Loading...
									<b-spinner
										v-if="updating_table"
										small
									></b-spinner>
								</b-alert>
							</b-col>
						</b-row>

						<b-row>
							<b-col>
								<small>Total: {{ totalRowsAll }} </small>
							</b-col>
							<b-col style="text-align: right; padding-right: 20px;">
								<b-button
									class="btn bt-sm btn-success"
									style="font-size: 12px; position: relative; bottom: 10px;"
									@click="download_records('All')"
									:disabled="csvDownloading"
									>
										<i class="fa fa-download"></i>&nbsp;{{ csvDownloading ? 'Downloading...' : 'Download' }}
										<b-spinner
											v-if="csvDownloading"
											small
										></b-spinner>
								</b-button>
							</b-col>
						</b-row>

						<b-table
							ref="view_all_records"
							striped
							hover
							:fields="view_fields"
							:items="myProvider"
							:current-page="currentPageAll"
							:per-page="perPageAll"
							filter="All"
						>
						</b-table>

						<b-row v-if="totalRowsAll > perPageAll">
							<b-col sm="12" md="12" class="my-1">
								<b-pagination
									v-model="currentPageAll"
									:total-rows="totalRowsAll"
									:per-page="perPageAll"
									align="fill"
									size="sm"
									class="my-0"
								></b-pagination>
							</b-col>
						</b-row>

					</b-card-text>
				</b-tab>

				<b-tab
					:title="'View Negombo Data'"
					@click="refresh_negombo_records_table"
					:disabled="uploading"
				>
					<b-card-text>
						<b-row>
							<b-col>
								<b-alert
									v-if="updating_table"
									show
								>
									Loading...
									<b-spinner
										v-if="updating_table"
										small
									></b-spinner>
								</b-alert>
							</b-col>
						</b-row>

						<b-row>
							<b-col>
								<small>Total: {{ totalRowsNegombo }} </small>
							</b-col>
							<b-col style="text-align: right; padding-right: 20px;">
								<b-button
									class="btn bt-sm btn-success"
									style="font-size: 12px; position: relative; bottom: 10px;"
									@click="download_records('Negombo')"
									:disabled="csvDownloading"
									>
										<i class="fa fa-download"></i>&nbsp;{{ csvDownloading ? 'Downloading...' : 'Download' }}
										<b-spinner
											v-if="csvDownloading"
											small
										></b-spinner>
								</b-button>
							</b-col>
						</b-row>

						<b-table
							ref="view_negombo_records"
							striped
							hover
							:fields="view_fields"
							:items="myProvider"
							:current-page="currentPageNegombo"
							:per-page="perPageNegombo"
							filter="Negombo"
						>
						</b-table>

						<b-row v-if="totalRowsNegombo > perPageNegombo">
							<b-col sm="12" md="12" class="my-1">
								<b-pagination
									v-model="currentPageNegombo"
									:total-rows="totalRowsNegombo"
									:per-page="perPageNegombo"
									align="fill"
									size="sm"
									class="my-0"
								></b-pagination>
							</b-col>
						</b-row>

					</b-card-text>
				</b-tab>

				<b-tab
					:title="'View Kelaniya Data'"
					@click="refresh_kelaniya_records_table"
					:disabled="uploading"
				>
					<b-card-text>
						<b-row>
							<b-col>
								<b-alert
									v-if="updating_table"
									show
								>
									Loading...
									<b-spinner
										v-if="updating_table"
										small
									></b-spinner>
								</b-alert>
							</b-col>
						</b-row>

						<b-row>
							<b-col>
								<small>Total: {{ totalRowsKelaniya }} </small>
							</b-col>
							<b-col style="text-align: right; padding-right: 20px;">
								<b-button
									class="btn bt-sm btn-success"
									style="font-size: 12px; position: relative; bottom: 10px;"
									@click="download_records('Kelaniya')"
									:disabled="csvDownloading"
									>
										<i class="fa fa-download"></i>&nbsp;{{ csvDownloading ? 'Downloading...' : 'Download' }}
										<b-spinner
											v-if="csvDownloading"
											small
										></b-spinner>
								</b-button>
							</b-col>
						</b-row>

						<b-table
							ref="view_kelaniya_records"
							striped
							hover
							:fields="view_fields"
							:items="myProvider"
							:current-page="currentPageKelaniya"
							:per-page="perPageKelaniya"
							filter="Kelaniya"
						>
						</b-table>

						<b-row v-if="totalRowsKelaniya > perPageKelaniya">
							<b-col sm="12" md="12" class="my-1">
								<b-pagination
									v-model="currentPageKelaniya"
									:total-rows="totalRowsKelaniya"
									:per-page="perPageKelaniya"
									align="fill"
									size="sm"
									class="my-0"
								></b-pagination>
							</b-col>
						</b-row>

					</b-card-text>
				</b-tab>

				<b-tab
					:title="'View Wattala Data'"
					@click="refresh_wattala_records_table"
					:disabled="uploading"
				>
					<b-card-text>
						<b-row>
							<b-col>
								<b-alert
									v-if="updating_table"
									show
								>
									Loading...
									<b-spinner
										v-if="updating_table"
										small
									></b-spinner>
								</b-alert>
							</b-col>
						</b-row>

						<b-row>
							<b-col>
								<small>Total: {{ totalRowsWattala }} </small>
							</b-col>
							<b-col style="text-align: right; padding-right: 20px;">
								<b-button
									class="btn bt-sm btn-success"
									style="font-size: 12px; position: relative; bottom: 10px;"
									@click="download_records('Wattala')"
									:disabled="csvDownloading"
									>
										<i class="fa fa-download"></i>&nbsp;{{ csvDownloading ? 'Downloading...' : 'Download' }}
										<b-spinner
											v-if="csvDownloading"
											small
										></b-spinner>
								</b-button>
							</b-col>
						</b-row>

						<b-table
							ref="view_wattala_records"
							striped
							hover
							:fields="view_fields"
							:items="myProvider"
							:current-page="currentPageWattala"
							:per-page="perPageWattala"
							filter="Wattala"
						>
						</b-table>

						<b-row v-if="totalRowsWattala > perPageWattala">
							<b-col sm="12" md="12" class="my-1">
								<b-pagination
									v-model="currentPageWattala"
									:total-rows="totalRowsWattala"
									:per-page="perPageWattala"
									align="fill"
									size="sm"
									class="my-0"
								></b-pagination>
							</b-col>
						</b-row>

					</b-card-text>
				</b-tab> -->

			</b-tabs>
		</b-card>

		<!-- modal view for accepted and rejected records -->
		<b-modal id="modal-1" size="lg" scrollable :title="set_modal_title">
      <b-table
        responsive
        :items="modal_items"
        :fields="modal_fields"
      />
    </b-modal>

	</div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import { mapGetters } from "vuex";

export default {
	mixins: [DashboardBaseTemplate],
	data() {
		return {
			baseUrl: `/srilanka/uploads-elisa/`,
			selectedFile: null,
			title: "",
			category: "IgG_ELISA",
			isPrivate: "",
			fields: [
				// not showing id
				{ key: "created", label: "Timestamp" },
				{ key: "upload", label: "Filename" },
				"accepted",
				"rejected"
			],
			uploads: [],
			// for loading spinner
			uploading: false,
			// set search category for SEARCH FILENAME
			search: {
				category: "IgG_ELISA"
			},
			// for modal table
      modal_items: [],
      modal_fields: [],
			// check accepted or rejected for modal table's title
			accepted: true,
			// check file error
			uploading_error: false,
			// check table is being updated
			updating_table: false,
			// for view records: made separate one
			totalRowsAll: 0,
      perPageAll: 15,
      currentPageAll: 1,
			totalRowsNegombo: 0,
      perPageNegombo: 15,
      currentPageNegombo: 1,
			totalRowsKelaniya: 0,
      perPageKelaniya: 15,
      currentPageKelaniya: 1,
			totalRowsWattala: 0,
      perPageWattala: 15,
      currentPageWattala: 1,

		// add view items & fields for table view
		view_fields: [
			{ key: 'blood_sample_id', label: "Blood Sample ID" },
			{ key: 'aliquot1_id', label: "Aliquot1 ID" },
			{ key: 'aliquot2_id', label: "Aliquot2 ID" },
			{ key: 'aliquot3_id', label: "Aliquot3 ID" },
			{ key: 'aliquot4_id', label: "Aliquot4 ID" },
			{ key: 'igg_elisa_od_value', label: "OD Value" },
			{ key: 'igg_elisa_result', label: "Result" },
		],
		// handling csv loadinf for download records
		csvDownloading: false,
		};
	},
	computed: {
		...mapGetters("user", ['inMyGroups']),
		set_modal_title() {
			return this.accepted ? "Accepted Aliquot barcode(s)" : "Rejected Aliquot barcode(s)"
		}
	},
	created() {
		this.find();
	},
	mounted() {},
	methods: {
		find() {
			// hide modal
			this.$bvModal.hide('modal-1');
			const that = this;
			HTTP.get(that.baseUrl, { params: { ...that.search } })
				.then((response) => {
					that.uploads = response.data;
				})
				.catch((error) => {
					HandleErrors.HandleErrors(error);
				});
		},
		download_elisa_rejected(item) {
			// show modal table
			this.$bvModal.show('modal-1');
			const that = this;
			const params ={
				id: item.id,
			}

			const downloadUrl = `/srilanka/blood_sample/download-elisa-rejected`;
      HTTP.get(downloadUrl, {params: params})
      .then(response => {
					that.modal_fields = response.data.modal_fields
					that.modal_fields = [
						{ key: response.data.modal_fields[0], label: "Barcode" },
						{ key: response.data.modal_fields[1], label: "OD value" },
						{ key: response.data.modal_fields[2], label: "Result" },
						{ key: response.data.modal_fields[3], label: "Message" },
					]
					that.modal_items = response.data.data
					// set data.accepted false
					that.accepted = false
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });

		},
		download_elisa_rejected_csv(item) {
			const that = this;
			const params ={
				return_as: 'csv',
				id: item.id,
			}

			const downloadUrl = `/srilanka/blood_sample/download-elisa-rejected`;
      HTTP.get(downloadUrl, {params: params})
      .then(response => {
				var fileURL = window.URL.createObjectURL(
						new Blob([response.data])
				);
				var fileLink = document.createElement("a");
				fileLink.href = fileURL;
				// date format: yyyy-mm-dd
				const filename = 'RejectedBarcode-' + item.upload;
				fileLink.setAttribute("download", filename);
				document.body.appendChild(fileLink);
				fileLink.click();
				that.csvLoading = false;
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });

		},
		download_elisa_accepted(item) {
			// show modal table
			this.$bvModal.show('modal-1');
			const that = this;
			const params ={
				id: item.id,
			}

			const downloadUrl = `/srilanka/blood_sample/download-elisa-accepted`;
      HTTP.get(downloadUrl, {params: params})
      .then(response => {
					that.modal_fields = response.data.modal_fields
					that.modal_fields = [
						{ key: response.data.modal_fields[0], label: "Barcode" },
						{ key: response.data.modal_fields[1], label: "OD value" },
						{ key: response.data.modal_fields[2], label: "Result" },
					]
					that.modal_items = response.data.data
					// for modal table's title
					that.accepted = true
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });

		},
		download_elisa_accepted_csv(item) {
			const that = this;
			const params ={
				id: item.id,
				return_as: 'csv'
			}

			const downloadUrl = `/srilanka/blood_sample/download-elisa-accepted`;
      HTTP.get(downloadUrl, {params: params})
      .then(response => {
				var fileURL = window.URL.createObjectURL(
              new Blob([response.data])
          );
				var fileLink = document.createElement("a");
				fileLink.href = fileURL;
				const filename = 'AcceptedBarcode-' + item.upload;
				fileLink.setAttribute("download", filename);
				document.body.appendChild(fileLink);
				fileLink.click();
				that.csvLoading = false;
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });

		},
		// for hiding modal
    beforeRouteLeave(to, from, next) {
      this.$bvModal.hide('modal-1');
      next();
    },
		onUpload: function () {
			const that = this;

			if (!that.selectedFile) {
				return that.$bvModal.msgBoxOk("Please select a file!", {
						title: "File Error",
						okVariant: "danger",
						centered: true,
				});
			}

			// initilaize uploading spinner
			that.uploading = true;
			// set initialize uploading_error to be false before upload
			that.uploading_error = false;

			const fd = new FormData();
			fd.append("file", that.selectedFile, that.selectedFile.name);
			fd.append("title", '');
			fd.append("category", that.category);

			HTTP.post(that.baseUrl, fd)
				.then(() => {
					that.selectedFile = null;
					that.$notify({
							text: "File successfully uploaded!",
							duration: 10000,
							type: "success",
					});

					that.selectedFile = null;
					that.title = "";
					that.isPrivate = false;
					that.sae_case = null;
					that.sae_selected = false;
					that.uploading_error = false;

					// load file table
					that.find();
				})
				.catch((error) => {
					HandleErrors.HandleErrors(error);
					// raise alert if uploading error occurs
					that.uploading_error = true;
				})
				.then(() => {
					that.uploading = false;
				});
		},
		// table view
    myProvider: function(ctx){
      const that = this;
      const params = {
        current_page: ctx.currentPage,
        per_page: ctx.perPage,
				category: that.category,
				city: ctx.filter
      };

			// check table is being updated
			that.updating_table = true;

      return HTTP.get("/srilanka/blood_sample/view-igg-elisa-records", {
        params: params
      }).then(response => {
				// check table is being updated
				that.updating_table = false;

				if (ctx.filter == 'Negombo') that.totalRowsNegombo = response.data.total_rows;
				else if (ctx.filter == 'Kelaniya') that.totalRowsKelaniya = response.data.total_rows;
				else if (ctx.filter == 'Wattala') that.totalRowsWattala = response.data.total_rows;
				else that.totalRowsAll = response.data.total_rows
				// since myProvider is called at b-table/items, response data should be returned
				return response.data.data

      }).catch((error) => {
        HandleErrors.HandleErrors(error);
				// check table is being updated
				that.updating_table = false;
      });
    },
    download_records: function(city){
      let that = this;
      let params = {
				return_as: 'csv',
				category: that.category,
				city: city
      }

			// initilaize uploading spinner
			that.csvDownloading = true;

      return HTTP.get("/srilanka/blood_sample/view-igg-elisa-records", {
        params: params
      }).then(response => {
				var fileURL = window.URL.createObjectURL(
              new Blob([response.data])
          );
				var fileLink = document.createElement("a");
				fileLink.href = fileURL;
				// date format: yyyy-mm-dd
				const filename = city + 'AcceptedBarcode-' + (new Date().toLocaleDateString('en-CA')) + '.csv';
				fileLink.setAttribute("download", filename);
				document.body.appendChild(fileLink);
				fileLink.click();
				that.csvLoadingAll = false;

      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      }).then(() => {
				that.csvDownloading = false;
			});
    },
		// refresh tables when switching tabs
		refresh_all_records_table: function () {
			this.$refs.view_all_records.refresh();
		},
		refresh_negombo_records_table: function () {
			this.$refs.view_negombo_records.refresh();
		},
		refresh_kelaniya_records_table: function () {
			this.$refs.view_kelaniya_records.refresh();
		},
		refresh_wattala_records_table: function () {
			this.$refs.view_wattala_records.refresh();
		},
	},
};
</script>
